import { useEffect, useState } from 'react';

/**
 * 열고 닫을 때 애니메이션을 위한 마운트 상태.
 * 열면 먼저 붙이고(숨긴 모습), 그 모습을 브라우저가 한 번 계산하게 한 뒤 shown 을 켜서 들어오는 전환이 보이게 한다.
 * 닫으면 shown 을 끈 뒤 ms 만큼 기다렸다가 뗀다 (나가는 전환이 끝난 다음).
 */
const usePresence = (open, ms = 300) => {
  const [mounted, setMounted] = useState(open);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      return undefined;
    }
    setShown(false);
    const timer = setTimeout(() => setMounted(false), ms);
    return () => clearTimeout(timer);
  }, [open, ms]);

  useEffect(() => {
    if (!mounted || !open) return;
    // 숨긴 모습을 먼저 확정해야 전환이 처음부터 보인다 (강제 리플로우)
    void document.body.offsetHeight;
    setShown(true);
  }, [mounted, open]);

  return { mounted, shown };
};

export default usePresence;
